CheckItem = require 'models/check-item'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'

module.exports = class CheckItemList extends CollectionWithHelpers
  model: CheckItem
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (checkItem) -> checkItem.get('pos')



// WEBPACK FOOTER //
// ./app/scripts/models/collections/check-item-list.coffee